/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export const serviceDeskIncomingEmailResource: RouteResource<IncomingEmailResponse> =
	createResource<IncomingEmailResponse>({
		type: 'SERVICE_DESK_INCOMING_EMAIL',
		getKey: ({
			match: {
				params: { projectKey },
			},
		}) => {
			return `SERVICE_DESK_INCOMING_EMAIL_${projectKey}`;
		},
		getData: ({
			match: {
				params: { projectKey },
			},
		}) =>
			performGetRequest<IncomingEmailResponse>(
				`/rest/servicedesk/1/servicedesk/${projectKey}/incomingemail`,
			),
		maxAge: 0,
	});

export type IncomingEmailResponse = {
	addButtonState: string;
	atlassianEmailPrefixSuggestion: string;
	canAdministerJira: boolean;
	canAdministerProject: boolean;
	canTurnOnOff: boolean;
	emailConfigured: boolean;
	emailDomain: string;
	expandHelpBubble: boolean;
	hasValidRequestType: boolean;
	incomingEmails: {
		broken: boolean;
		channelStatus: string;
		defaultReplyTo: boolean;
		emailAddress: string;
		enabled: boolean;
		host: string;
		iconUrl: string;
		id: number;
		lastProcessedTime: number;
		mailChannelKey: string;
		notificationPreference: { admin: boolean; helpseeker: boolean };
		onDemand: boolean;
		port: string;
		protocol: string;
		requestTypeIcon: number;
		requestTypeId: number;
		requestTypeName: string;
		username: string;
	}[];
	isPublicSignupEnabled: boolean;
	onDemand: boolean;
	outgoingMailConfigured: boolean;
	portalKey: string;
	projectKey: string;
	totalEmailLimit: 10;
};
